// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { AdjustIcon } from '@moia-dev/pace-icons'
import { MobileAppFlavorConfigAreaRoutes } from './MobileAppFlavorConfigAreaRoutes'

export const MobileAppFlavorConfigAreaNavigationIcon = AdjustIcon

export const MobileAppFlavorConfigAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={MobileAppFlavorConfigAreaRoutes.route}
      Icon={AdjustIcon}
    />
  )
}
